import axios from 'axios';

// Configure axios to use the API base URL
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://localhost:7271/api';

// Add authorization token to all requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface UserDto {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  permissionLevel: number;
  permissionLevelName: string;
  isSupervisor: boolean;
  isPartialSupervisor: boolean;
  isActive: boolean;
  defaultCommissionFixedAmount: number;
  defaultCommissionPercentage: number;
  createdAt: string;
  updatedAt: string;
}

// ===== שינוי רמת הרשאה (תפקיד) של משתמש קיים =====

// קטגוריית הישויות המושפעות (נגזרת מהתפקיד הנוכחי) — חייב להתאים ל-enum בבקאנד
export enum RoleChangeAffectedCategory {
  None = 0,
  Leads = 1,
  Clients = 2,
  SecretaryLinks = 3,
}

// אופן הטיפול בלידים של נציג שיוצא מהתפקיד
export enum RoleChangeLeadHandling {
  Unassign = 0,
  Reassign = 1,
}

// אופן הטיפול בלקוחות של מנהל תיק שיוצא מהתפקיד
export enum RoleChangeClientHandling {
  Transfer = 0,
  Unassign = 1,
}

// אופן המרת קישורי מזכירה לבעלות
export enum SecretaryConversionMode {
  None = 0,
  All = 1,
  OnlyUnassigned = 2,
}

export interface RoleChangeImpact {
  oldPermissionLevel: number;
  newPermissionLevel: number;
  affectedCategory: RoleChangeAffectedCategory;
  leadCount: number;
  clientCount: number;
  secretaryLeadCount: number;
  secretaryClientCount: number;
  clientsWithoutManagerCount: number;
  unassignedLeadCount: number;
}

export interface ChangePermissionLevelPayload {
  newPermissionLevel: number;
  isSupervisor: boolean;
  leadHandling: RoleChangeLeadHandling;
  targetSalesRepId?: number | null;
  clientHandling: RoleChangeClientHandling;
  targetCaseManagerId?: number | null;
  secretaryConversion: SecretaryConversionMode;
}

export const usersApi = {
  getSalesReps: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users/sales-reps');
    return response.data;
  },

  getCaseManagers: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users/case-managers');
    return response.data;
  },

  getAll: async (): Promise<UserDto[]> => {
    const response = await axios.get('/users');
    return response.data;
  },

  getRoleChangeImpact: async (userId: number, newPermissionLevel: number): Promise<RoleChangeImpact> => {
    const response = await axios.get(`/users/${userId}/role-change-impact`, {
      params: { newPermissionLevel },
    });
    return response.data;
  },

  changePermissionLevel: async (userId: number, payload: ChangePermissionLevelPayload): Promise<UserDto> => {
    const response = await axios.put(`/users/${userId}/permission-level`, payload);
    return response.data;
  },
};